<template>
  <div>
    <div class="d-flex justify-content-between mb-4">
      <div>
        <button type="button" class="btn btn-success" @click="exportData">
          <i class="fa fa-file-text-o"></i> Excel
        </button>
      </div>
      <div class="d-flex">
        <div class="d-flex">
          <div class="d-flex align-items-center mr-2">
            <label for="search" class="mr-2 mb-0">Search: </label>
            <input
              v-model="search.value"
              type="text"
              class="form-control"
              id="search"
            />
          </div>
          <div class="mr-2">
            <select v-model="search.field" class="form-control">
              <option value="instansi_pemohon">Nama Pemohon</option>
              <option value="nomor_permohonan">Nomor Pemohon</option>
              <option value="jenis_kegiatan">Jenis Kegiatan</option>
              <option value="tanggal_permohonan">Tgl Permohonan</option>
            </select>
          </div>
          <button
            type="button"
            class="btn btn-outline-secondary"
            @click="handleSearch"
          >
            <i class="fa fa-search"></i>
          </button>
        </div>
        <div class="d-flex ml-4">
          <div class="d-flex align-items-center mr-2">
            <label for="search" class="mb-0">Sort By: </label>
          </div>
          <div>
            <select v-model="sort.field" class="form-control">
              <option value="createdAt">Tgl Submit</option>
              <option value="tanggal_permohonan">Tgl Permohonan</option>
            </select>
          </div>
          <div class="ml-2">
            <select v-model="sort.direction" class="form-control">
              <option value="DESC">DESC</option>
              <option value="ASC">ASC</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <table class="table">
      <thead>
        <tr>
          <th scope="col">No</th>
          <th scope="col">Nama Pemohon</th>
          <th scope="col">Nomor Pemohon</th>
          <th scope="col">Jenis Kegiatan</th>
          <th scope="col">Tgl Permohonan</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="d in dataPermohonan">
          <td>{{ d.no }}</td>
          <td>
            <div style="width: 300px; text-wrap: wrap">
              {{ d.instansi_pemohon }}
            </div>
          </td>
          <td>{{ d.nomor_permohonan }}</td>
          <td>
            <div style="width: 300px; text-wrap: wrap">
              {{ d.jenis_kegiatan }}
            </div>
          </td>
          <td>{{ d.tanggal_permohonan }}</td>
        </tr>
      </tbody>
    </table>
    <div class="d-flex justify-content-between">
      <div>{{ pagesText }}</div>
      <ul class="pagination mb-0">
        <li class="page-item">
          <button
            class="page-link"
            @click="goToPage(pagination.currentPage - 1)"
          >
            <span aria-hidden="true">&laquo;</span>
          </button>
        </li>
        <li v-for="page in pages" class="page-item">
          <button
            :class="{
              'page-link': true,
              active: page == pagination.currentPage,
            }"
            @click="goToPage(page)"
          >
            {{ page }}
          </button>
        </li>
        <li class="page-item">
          <button
            class="page-link"
            @click="goToPage(pagination.currentPage + 1)"
          >
            <span aria-hidden="true">&raquo;</span>
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { formatDate } from '../../../../../helper/helpernew'
import dayjs from 'dayjs'
import * as xlsx from 'xlsx'
import Swal from 'sweetalert2'

export default {
  props: ['filterTahun', 'jenisTahap'],
  data() {
    return {
      baseapi: localStorage.getItem('baseapi') || '',
      user: JSON.parse(localStorage.getItem('user') || '{}'),
      dataPermohonan: [],
      filterQueryTahap: '', // Menyimpan string query tambahan dari jenisTahap

      pagination: {
        currentPage: 1,
        totalPages: 1,
        limit: 10,
        total: 0,
      },
      search: {
        field: 'instansi_pemohon',
        value: '',
      },
      sort: {
        field: 'createdAt',
        direction: 'DESC',
      },
    }
  },
  mounted() {
    this.updateFilterTahap(this.jenisTahap)
    this.loadData()
  },
  watch: {
    // Watcher untuk memantau perubahan props jenisTahap
    jenisTahap: {
      immediate: true,
      handler(val) {
        this.updateFilterTahap(val)
        this.pagination.currentPage = 1 // Reset ke halaman 1 setiap kali filter berubah
        this.loadData()
      },
    },
    // Watcher untuk memantau perubahan props filterTahun
    filterTahun() {
      this.pagination.currentPage = 1
      this.loadData()
    },
  },
  methods: {
    // Helper method untuk memetakan nama stage ke string filter query
    updateFilterTahap(val) {
      if (val === 'Penjadwalan') {
        this.filterQueryTahap = ';status_permohonan,!=,Permohonan telah dibuat oleh pemohon;status_permohonan,!=,Permohonan telah disubmit oleh pemohon;status_permohonan,!=,Menunggu Verifikasi Dokumen;status_permohonan,!=,Perbaikan Persyaratan;keterangan_status,=,Perbaikan Persyaratan'
      } else if (val === 'Verifikasi Dokumen') {
        this.filterQueryTahap = ';status_permohonan,!=,Permohonan telah dibuat oleh pemohon'
      } else if (val === 'Penilaian Teknis') {
        this.filterQueryTahap = ';status_permohonan,!=,Permohonan telah dibuat oleh pemohon;status_permohonan,!=,Permohonan telah disubmit oleh pemohon;status_permohonan,!=,Menunggu Verifikasi Dokumen;status_permohonan,!=,Perbaikan Persyaratan;keterangan_status,=,Perbaikan Persyaratan;status_permohonan,!=,Dokumen Lengkap;status_permohonan,!=,Menunggu Jadwal Penilaian Teknis'
      }else if (val === 'Pembayaran PNBP') {
        this.filterQueryTahap = ';status_permohonan,!=,Permohonan telah dibuat oleh pemohon;status_permohonan,!=,Permohonan telah disubmit oleh pemohon;status_permohonan,!=,Menunggu Verifikasi Dokumen;status_permohonan,!=,Perbaikan Persyaratan;keterangan_status,=,Perbaikan Persyaratan;status_permohonan,!=,Dokumen Lengkap;status_permohonan,!=,Menunggu Jadwal Penilaian Teknis;status_permohonan,!=,Penilaian Teknis;status_permohonan,!=,Tim Teknis Pembuatan Berita Acara Hasil Penilaian Teknis'
      }else if (val === 'Penerbitan') {
        this.filterQueryTahap = ';file_final_oss,!=,null'
      }  else {
        // Jika props jenisTahap sudah berupa string query dari parent, gunakan langsung
        this.filterQueryTahap = val || ''
      }
    },

    async loadData() {
      const firstDate = `${this.filterTahun}-01-01`
      const lastDate = `${this.filterTahun}-12-31`

      const api =
        `api/permohonan_nonberusaha/dataTable` +
        `?page=${this.pagination.currentPage}` +
        `&filter=tanggal_permohonan,>=,${firstDate};tanggal_permohonan,<=,${lastDate}${this.filterQueryTahap}` +
        `${
          this.search.value !== ''
            ? `;${this.search.field},${
                this.search.field === 'tanggal_permohonan' ? '=' : 'like'
              },${this.search.value}`
            : ''
        }` +
        `&sort=${this.sort.field},${this.sort.direction}`

      try {
        const res = await axios.get(this.baseapi + api, this.getApiOption())
        const resData = res.data
        this.pagination.totalPages = Math.ceil(resData.total / (resData.limit || this.pagination.limit))
        this.pagination.total = resData.total

        const { currentPage, limit } = this.pagination
        this.dataPermohonan = (resData.data || []).map((d, i) => {
          return {
            ...d,
            no: (currentPage - 1) * limit + i + 1,
            tanggal_permohonan: formatDate(d.tanggal_permohonan, 'DD MMMM YYYY'),
          }
        })
      } catch (error) {
        console.error('Gagal memuat data nonberusaha:', error)
        this.dataPermohonan = []
      }
    },

    handleSearch() {
      this.pagination.currentPage = 1
      this.loadData()
    },

    async exportData() {
      if (this.$loading) this.$loading(true)
      try {
        const firstDate = `${this.filterTahun}-01-01`
        const lastDate = `${this.filterTahun}-12-31`

        const api =
          `api/permohonan_nonberusaha` +
          `?sort=${this.sort.field},${this.sort.direction}` +
          `&filter=tanggal_permohonan,>=,${firstDate};tanggal_permohonan,<=,${lastDate}${this.filterQueryTahap}` +
          `${
            this.search.value !== ''
              ? `;${this.search.field},${
                  this.search.field === 'tanggal_permohonan' ? '=' : 'like'
                },${this.search.value}`
              : ''
          }`

        const res = await axios.get(this.baseapi + api, this.getApiOption())

        const worksheetData = [
          ['Data Permohonan'],
          [
            'No',
            'Prioritas',
            'Nama Pemohon',
            'Nomor Pemohon',
            'Jenis Kegiatan',
            'Nama Perairan',
            'Provinsi',
            'Status Verdok',
            'Status Pentek',
            'Tgl. Permohonan',
            'Tgl. Proses',
            'Tgl. Berlaku Tagihan',
            'Status Tagihan',
            'PIC Pentek',
          ],
        ]
        const merge = [
          { s: { c: 0, r: 0 }, e: { c: worksheetData[1].length - 1, r: 0 } },
        ]

        ;(res.data.data || []).forEach((d, i) => {
          worksheetData.push([
            i + 1,
            d.prioritas ? 'Prioritas' : '',
            d.instansi_pemohon,
            d.nomor_permohonan,
            d.jenis_kegiatan,
            d.nama_perairan,
            d.lokasi,
            d.status_verdok,
            d.status_vertek,
            d.tanggal_permohonan,
            d.tanggal_proses,
            d.tanggal_berlaku_hingga_tagihan_iii
              ? d.tanggal_berlaku_hingga_tagihan_iii
              : d.tanggal_berlaku_hingga_tagihan_ii
              ? d.tanggal_berlaku_hingga_tagihan_ii
              : d.tanggal_berlaku_hingga_tagihan_i
              ? d.tanggal_berlaku_hingga_tagihan_i
              : '',
            d.status_tagihan_iii
              ? d.status_tagihan_iii
              : d.status_tagihan_ii
              ? d.status_tagihan_ii
              : d.status_tagihan_i
              ? d.status_tagihan_i
              : '',
            d.pic_name,
          ])
        })

        const workbook = xlsx.utils.book_new()
        const worksheet = xlsx.utils.aoa_to_sheet(worksheetData)
        worksheet['!merges'] = merge
        xlsx.utils.book_append_sheet(workbook, worksheet, 'Sheet1')

        xlsx.writeFile(
          workbook,
          `Data Permohonan ${dayjs().format('YYYY-MM-DD')}.xlsx`
        )
      } catch (e) {
        Swal.fire('Gagal', 'Gagal mengekspor data', 'error')
      } finally {
        if (this.$loading) this.$loading(false)
      }
    },

    goToPage(page) {
      if (
        page >= 1 &&
        page <= this.pagination.totalPages &&
        page !== this.pagination.currentPage
      ) {
        this.pagination.currentPage = Number(page)
        this.loadData()
      }
    },

    generatePagination(currentPage, totalPages) {
      const [cp, tp] = [currentPage, totalPages]
      const pagination = []
      if (tp <= 7) {
        for (let i = 1; i <= tp; i++) pagination.push(`${i}`)
      } else {
        if (cp <= 3) {
          pagination.push('1', '2', '3', '4', '5', '...', `${tp}`)
        } else if (cp >= tp - 2) {
          pagination.push('1', '...', `${tp - 4}`, `${tp - 3}`, `${tp - 2}`, `${tp - 1}`, `${tp}`)
        } else {
          pagination.push('1', '...', `${cp - 1}`, `${cp}`, `${cp + 1}`, '...', `${tp}`)
        }
      }
      return pagination
    },

    getApiOption() {
      return {
        headers: {
          Authorization: `Bearer ` + (this.user?.accessToken || ''),
        },
      }
    },

    resetFilter() {
      this.pagination = {
        currentPage: 1,
        totalPages: 1,
        limit: 10,
        total: 0,
      }
      this.search = {
        field: 'instansi_pemohon',
        value: '',
      }
      this.sort = {
        field: 'createdAt',
        direction: 'DESC',
      }
    },
  },
  computed: {
    pages() {
      return this.generatePagination(
        this.pagination.currentPage,
        this.pagination.totalPages
      )
    },
    pagesText() {
      const { currentPage, limit, total } = this.pagination
      const startData = (currentPage - 1) * limit + 1
      const endData = Math.min(currentPage * limit, total)
      if (total <= 0) return 'Tidak ada data'
      return `Menampilkan ${startData} sampai ${endData} dari ${total} data`
    },
  },
}
</script>
